import React from "react";

import Carousel from "react-bootstrap/Carousel";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";

const Gallery = () => {
  const galleryPhotos = 7;
  return (
    <React.Fragment>
      <Container style={{ paddingBottom: "4em" }}>
        <Row className="centrado">
          <h1 className="encabezado">Conoce nuestro trabajo</h1>
        </Row>
        <Row className="centrado">
          <Carousel>
            {[...Array(galleryPhotos).keys()].map((key) => {
              let path = `./assets/images/slider/${key + 1}.jpg`;
              let alt = `slide_image_${key + 1}.jpg`;
              return (
                <Carousel.Item interval={3000} key={alt}>
                  <Image
                    src={path}
                    width="700px"
                    height="550px"
                    fluid
                    alt={alt}
                  />
                </Carousel.Item>
              );
            })}
          </Carousel>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Gallery;
